module.exports = __webpack_public_path__ + "media/images/detail-97d249dacca09785cfa9e0b6c29a54fe.svg";